export const environment = {
  production: true,
  envName: 'production',
  title: 'Production Environment Heading',
  webURL: 'https://cefes.lubrikuv.com/',
  apiURL: 'https://cefes-back.lubrikuv.com/',
  kPagosURL: 'https://kpagos.kuvesoft.xyz/',
  habilitarSuscripciones: true,
  version: '6.2.0'
};
